import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Grow,
  Button,
  TextField,
} from '@mui/material';
import images from '../src/assests/images/bk_img1.jpg';
import logo from '../src/assests/images/logo1.png';

const MFASetup = () => {
  const [mfaCode, setMfaCode] = useState('');
  const [showCard, setShowCard] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setShowCard(true);
  }, []);

  const handleVerifyMFA = () => {
    // Handle MFA verification
    if (mfaCode.trim()) {
      // Verify MFA code logic here
      navigate("/Homepage");
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        height: "100vh",
        width: "100%",
        overflow: "hidden",
        // Background image styling
        backgroundImage: `url(${images})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Semi-transparent overlay to improve text readability */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.4)", // Dark overlay for better contrast
          zIndex: 0,
        }}
      />

      {/* Centered card with animation */}
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
        px={2}
        position="relative" // Ensure it's above the overlay
        zIndex={1}
      >
        <Grow in={showCard} timeout={1000}>
          <Card
            sx={(theme) => ({
              width: {
                xs: "90%",
                sm: "65%",
                md: "45%",
                lg: "35%",
                xl: "28%",
              },
              maxWidth: 450,
              padding: 2,
              backgroundColor: "rgba(255, 255, 255, 0.95)", // Slightly transparent white
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              boxShadow: 3,
              borderRadius: 2,
              backdropFilter: "blur(5px)", // Frosted glass effect
            })}
          >
            <CardContent
              sx={{ width: "100%", p: 1, "&:last-child": { pb: 1 } }}
            >
              {/* Logo with description below */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  mb: 1.5,
                }}
              >
                <img
                  src={logo}
                  alt="Lucas TVs Logo"
                  style={{ width: "100%", maxWidth: "150px", height: "auto" }}
                />
                <Typography
                  variant="subtitle1"
                  align="center"
                  color="text.primary"
                  fontSize="16px"
                  fontWeight="Bold"
                  sx={{ marginTop: 0.5 }}
                >
                  MFA
                </Typography>
              </Box>

              {/* MFA Message */}
              <Typography
                variant="h6"
                align="center"
                sx={{ mb: 2, color: "text.primary" }}
              >
                Multi-Factor Authentication Required
              </Typography>

              <Typography
                variant="body1"
                align="center"
                sx={{ mb: 3, color: "text.secondary" }}
              >
                Please enter your MFA code to continue.
              </Typography>

              {/* MFA Code Input */}
              <TextField
                label="MFA Code"
                variant="outlined"
                fullWidth
                margin="dense"
                size="small"
                value={mfaCode}
                onChange={(e) => setMfaCode(e.target.value)}
                sx={{ mb: 2 }}
              />

              {/* Buttons */}
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Button
                  variant="contained"
                  size="small"
                  fullWidth
                  sx={{
                    paddingX: 3,
                    fontSize: "0.9rem",
                    backgroundImage: "linear-gradient(45deg, #7DF9FF, #00BFFF)",
                    "&:hover": {
                      backgroundImage: "linear-gradient(45deg, #00BFFF, #7DF9FF)",
                    },
                    height: "40px",
                  }}
                  onClick={handleVerifyMFA}
                >
                  Verify MFA
                </Button>

                <Button
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{
                    paddingX: 3,
                    fontSize: "0.9rem",
                    height: "40px",
                    borderColor: "#00BFFF",
                    color: "#00BFFF",
                    "&:hover": {
                      borderColor: "#7DF9FF",
                      color: "#7DF9FF",
                    },
                  }}
                  onClick={() => navigate("/")}
                >
                  Back to Login
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grow>
      </Box>
    </Box>
  );
};

export default MFASetup;